import { SIZE_FILTER_TREE } from '@/constants/endpoints';
import { typedHttp } from '@/modules/http';

export function fetchSizeFilterTree() {
  return typedHttp.get(SIZE_FILTER_TREE, {
    cache: 'force-cache',
  });
}
